export default "assets/facebook-de52e91c.svg";